import { render, staticRenderFns } from "./VKIcon.vue?vue&type=template&id=22c7f97d&"
import script from "./VKIcon.vue?vue&type=script&lang=js&"
export * from "./VKIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports